/**
 * Output safety for marketing lead values. Leads come from public website forms,
 * so every stored string is attacker-controlled by the time it reaches the founder.
 */

/**
 * One CSV cell, per the OWASP CSV injection guidance: a text value a spreadsheet
 * would read as a formula gets a leading single quote, then normal CSV quoting.
 * Numbers are left alone, so a real negative number stays a number.
 */
export function csvCell(value: unknown): string {
  if (value === undefined || value === null) return '';
  if (typeof value === 'number') return String(value);
  const text = String(value);
  const neutralised = /^\s*[=+\-@]|^[\t\r]/.test(text) ? `'${text}` : text;
  return /[",\r\n]/.test(neutralised) ? `"${neutralised.replace(/"/g, '""')}"` : neutralised;
}

/** http(s), or a path on this site. Refuses javascript:, data: and "//host". */
export function isSafeLinkHref(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  if (value.startsWith('/')) return !value.startsWith('//') && !value.includes('\\');
  try {
    const { protocol } = new URL(value);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}
